import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useUserActions } from 'src/store/users/actions';
interface Props {
    show: boolean;
    onClose: () => void;
    onRegister: (emails: string[], file: File | null) => void;
}

const RegisterUsersModal: React.FC<Props> = ({ show, onClose, onRegister }) => {
    const dispatch = useDispatch();
    const userAction = useUserActions(dispatch);
    const btnRef = useRef<HTMLButtonElement>(null);
    const [emails, setEmails] = useState('');
    const [file, setFile] = useState<File | null>(null);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const emailList = emails.split(/[\s,]+/).filter((e) => e.includes('@'));
        onRegister(emailList, file);
        setEmails('');
        setFile(null);
        if (btnRef.current) btnRef.current.click();
    };

    return (
        <div
            className={`modal fade ${show ? 'show block' : 'hidden'}`}
            id="registerUsersModal"
            aria-labelledby="registerUsersModalLabel"
            aria-hidden={!show}>
            <div className="modal-dialog relative w-auto pointer-events-none max-w-xl">
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white rounded-md outline-none">
                    <div className="modal-header flex items-center justify-between p-4 pb-2">
                        <h5 className="text-xl font-semibold text-center w-full" id="registerUsersModalLabel">
                            Register Users for Course
                        </h5>
                        <button
                            ref={btnRef}
                            type="button"
                            className="dismiss-btn"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={onClose}></button>
                    </div>

                    <div className="modal-body py-4 px-10">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group mb-4">
                                <label className="block mb-1">Enter Emails separated by semicolons (;) </label>
                                <textarea
                                    value={emails}
                                    onChange={(e) => setEmails(e.target.value)}
                                    className="input-style w-full"
                                    rows={4}
                                    placeholder="user1@example.com; user2@example.com"
                                />
                            </div>

                            <div className="form-group mb-4">
                                <label className="block mb-1">Or Upload CSV</label>
                                <input
                                    type="file"
                                    accept=".csv"
                                    onChange={(e) => setFile(e.target.files ? e.target.files[0] : null)}
                                    className="input-style"
                                />
                            </div>

                            <div className="modal-footer flex justify-center p-4">
                                <button type="submit" className="btn-primary mr-2">
                                    Register
                                </button>
                                <button
                                    type="button"
                                    className="btn-primary discard-btn "
                                    data-bs-dismiss="modal"
                                    onClick={onClose}>
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegisterUsersModal;
